export default {
    '1d-diagram4': {
        'diagram-task': 'Type your answer in the white box.<br>Then click the ‘reveal’ button to see how it compares to the correct answer',
      'diagram-description': `<li>Jacobitism satisfied a deep utopian longing for the perfect society</li>
                                <li>Eighteenth-century Britain notoriously lacked stability</li>
                                <li>The Jacobites detested the new rising competitive capitalize society and harmony</li>
                                <li>Support for the Jacobite rebellion was driven by nostalgia for a lost world</li>`,
        'fixed-answer1': 'Support for the Jacobite rebellion was driven by nostalgia for a lost world',
        'fixed-answer2': 'Wanted stability A rural-based community that was stable and harmonious',
        'fixed-answer3': 'Wanted harmony Free from the new competitive capitalism',
        'fixed-answer4': 'Wanted social order A hierarchy of pre-ordained places where inferiors obey superiors'
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/1/1d/diagram4/i18n/en.js